import {styled} from "@mui/material/styles";
import {FormControlLabel} from "@mui/material";
import ModeEditIcon from '@mui/icons-material/ModeEdit';

export const StyledModeEditIcon = styled(ModeEditIcon)(() => ({
	position: 'absolute',
	right: '5px',
	top: '13px',
}))

export const ControlLabel = styled(FormControlLabel, {
	shouldForwardProp: (prop) =>
		prop !== 'checked'
})<{ checked: boolean }>(({checked, theme}) => ({
	width: '100%',
	padding: '8px',
	borderRadius: '5px',
	margin: '0 1px',
	position: 'relative',
	background: theme.palette.background.default,
	color: theme.palette.secondary.main,
	borderWidth: '1px',
	borderStyle: 'solid',
	borderColor: checked ? theme.palette.primary.light : theme.palette.secondary.main,
	boxSizing: 'border-box',
	userSelect: 'none',
	cursor: 'pointer',
	'& .MuiTypography-root': {
		width: '100%',
		color: theme.palette.textAccent.light,
	},
}))

export const RadioWrapper = styled('div')(() => ({
	display: 'flex',
	justifyContent: 'center',
}))

export const LabelWrapper = styled('div')(() => ({
	display: 'flex',
	justifyContent: 'space-between'
}))

export const Popular = styled('div')(({theme}) => ({
	marginRight: '15px',
	backgroundColor: theme.palette.primary.light,
	borderRadius: '50px',
	padding: '0px 8px',
	color: "#FFFFFF",
	fontFamily: 'Circular',
	fontSize: '10px'
}))
